<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
  import { messageListener, readyNotify } from "./util/h5sdkevent.js";
  export default {
    computed:{
      target () {
        return this.$store.state.target;
      }
    },
    watch:{
      target(newVal, oldVal) {
        // console.log(oldVal)
        // console.log(newVal)
        // console.log(this.$router.history.current)
        if(newVal.cPath.length>0){
          this.$router.push({name:newVal.cPath})
        }else{
          const nPath = newVal.path.substr(newVal.path.indexOf('#')+2)
          try {
            if (nPath.indexOf(this.$route.meta.page) == -1) {
              //当目标界面和当前界面不一致的时候才跳转
              this.$router.push({name: nPath})
            }
          }catch (e){
            this.$router.push({name: nPath})
          }
        }
      }
    },
    data(){
      return {
        metaArray: [],
        routeArray: []
      };
    },
    created() {
      messageListener();
      readyNotify();
      this.$router.history.listen((route => {
        this.$router.apps.forEach(app => {
          //上一个界面
          console.log(app._route)
          //下一个界面
          console.log(route)
          console.log(this.routeArray)
          //正常的网页都是有page的
          if(route.name!==null&&route.meta&&route.meta.page){
            //判断当前界面为别的界面跳转
            if(app._route&&app._route.meta&&app._route.meta.go){
              let pageIndex = this.metaArray.indexOf(app._route.meta.page)
              //如果是主界面又不是当前tab，则说明是点的底部导航栏
              // eslint-disable-next-line no-empty
              if((route.meta.page==route.name||route.redirectedFrom)&&route.meta.page!=app._route.meta.page){
                if(app._route.meta.go==-3) {//一部分根目录不需要保存
                  app._route.meta.go=undefined
                  this.metaArray.splice(pageIndex, 1);
                  this.routeArray.splice(pageIndex, 1);
                }
              }else {
                //否则移除当前界面
                this.metaArray.splice(pageIndex, 1);
                this.routeArray.splice(pageIndex, 1);
              }
              if(app._route.meta.go==-1) {
                //返回上一界面
                app._route.meta.go=undefined
                //如果被重定向,则说明也是主界面，需要返回子界面
                if(route.matched.length>1) {
                  pageIndex = this.metaArray.indexOf(route.meta.page)
                  app._route = this.routeArray[pageIndex]
                }else {
                  //跳转到目标界面
                  app._route = route
                }
                window.parent.postMessage(
                    {
                      func: "goTabBarPage", // 指令名
                      params: {path: route.meta.page, gamePageUrl: ""},
                    },
                    "*"
                );
                // console.log('返回上个界面')
              }else if(app._route.meta.go==1){
                //返回上一界面
                app._route.meta.go=undefined
                //再次判断坐标
                pageIndex = this.metaArray.indexOf(app._route.meta.page)
                if(pageIndex==-1) {
                  //如果不存在则重新打开一个
                  window.parent.postMessage(
                      {
                        func: "goTabBarPage", // 指令名
                        params: {path: route.meta.page, gamePageUrl: ""},
                      },
                      "*"
                  );
                }else{
                  //存在则跳转上一个子界面
                  app._route = this.routeArray[pageIndex]
                }
                // console.log('返回上层界面')
              }else{
                window.parent.postMessage(
                    {
                      func: "goTabBarPage", // 指令名
                      params: {path: route.meta.page, gamePageUrl: ""},
                    },
                    "*"
                );
                //来时的界面如果还在就打开来时的界面，如果不在就新界面
                const oRoute = this.routeArray.find((r) => r.name == route.name)
                if(oRoute) {
                  app._route = oRoute
                }else {
                  //如果历史界面不存在，则开启新界面
                  this.metaArray.unshift(route.meta.page)
                  this.routeArray.unshift(route)
                  // console.log('开启新界面')
                  app._route = route
                }
              }
            }else if((route.meta.page==route.name||route.redirectedFrom)&&this.metaArray.includes(route.meta.page)){
              //如果该界面打开过该主界面，则直接定位到原界面的子界面
              const pageIndex = this.metaArray.indexOf(route.meta.page)
              app._route = this.routeArray[pageIndex]
              this.$router.history.current = app._route;
              // console.log('使用缓存,并重新设置当前地址，防止后面自己跳自己出BUG')
            }else {
              // console.log(app._route)
              // console.log(route)
              if(app._route&&app._route.meta.page!=route.meta.page){
                window.parent.postMessage(
                    {
                      func: "goTabBarPage", // 指令名
                      params: {path: route.meta.page, gamePageUrl: ""},
                    },
                    "*"
                );
              }
              //如果不是主界面也不是返回，则寻找历史界面
              //如果历史界面存在，则直接跳转
              const oRoute = this.routeArray.find((r) => r.name == route.name)
              if(oRoute) {
                this.metaArray.shift(oRoute.meta.page)
                this.routeArray.shift(oRoute)
                this.metaArray.unshift(oRoute.meta.page)
                this.routeArray.unshift(oRoute)
                app._route = oRoute
                // console.log('直接跳转')
              }else {
                //如果历史界面不存在，则开启新界面
                this.metaArray.unshift(route.meta.page)
                this.routeArray.unshift(route)
                // console.log('开启新界面')
                app._route = route
              }
            }
          }else{
            app._route = route
          }
        })
      }))
    }
  };
</script>
<style lang="scss">
  #app {
    display: inline-block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    background: #F8F8F8;
  }
</style>
